// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cart-widget__items__item+.cart-widget__items__item{padding-top:1.5em}", ""]);
// Exports
module.exports = exports;
